/** @format */

import {useRef, useState} from 'react';

import {useNavigate} from 'react-router-dom';

import {useMixpanelContext} from 'contexts/MixpanelContext';
import {useCompanyContext} from 'contexts/CompanyContext';

import {DigitalCastIcon} from '../DigitalCastIcon';
import {ButtonText, HoverBg, ImageBox, Root, TextBox} from './styles';

interface Props {
  overrideHeight?: string;
}

const DigitalCastButton = ({overrideHeight}: Props) => {
  const [hover, setHover] = useState<boolean>(false);

  const ref = useRef<HTMLButtonElement>(null);

  const navigate = useNavigate();
  const {mixpanel} = useMixpanelContext();
  const {currentCompany} = useCompanyContext();

  const handleDigitalCastClick = () => {
    mixpanel.track('click_project_digital_cast_button', {project_uuid: currentCompany.uuid});
    navigate('/home/digital-cast');
  };

  return (
    <Root
      onClick={handleDigitalCastClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      ref={ref}
      overrideHeight={overrideHeight}
    >
      <ImageBox />
      <HoverBg hover={hover} />
      <TextBox>
        <DigitalCastIcon animate={hover} />
        <ButtonText>Цифровой слепок</ButtonText>
      </TextBox>
    </Root>
  );
};

export {DigitalCastButton};
